// A Klaviyo-connected domain delivers email through Klaviyo, and transactional sending there
// requires Klaviyo-side approval (Klaviyo holds the transactional flow "Under review" until
// then). Campaign/workflow editors disable the Transactional scope until it is approved, so a
// campaign can't be built to silently not send (the backend preflight also blocks it).
//
// Gated on `loading === false` like the other klaviyoSlice consumers: the slice nulls `account`
// on every refetch, so reading `account` alone would flicker the option back to enabled.
// A `credentialsInvalid` account still counts as connected here (unlike SettingsTabKlaviyo,
// which offers a reconnect): a broken connection can't deliver transactional email either, so
// the scope stays disabled until the connection is repaired and approval re-checked.
//
// Takes the whole `state.klaviyo` slice so callers can pass the selector result straight in.
const isTransactionalScopeDisabled = ({ account, loading } = {}) =>
  loading === false && Boolean(account) && account.transactionalApproved !== true;

export default isTransactionalScopeDisabled;
